import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";
import * as constants from "../constants/CONSTANT";
import moment from "moment";
const StudentAssessmentEdit = (prop) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [staffMember, setStaffMember] = useState([]);

  const [assessment, setAssessment] = useState(
    location.state ? location.state : {}
  );
  console.log('assessment',assessment);

  const [isEditable, setIsEditable] = useState(true);
  const [studentassessment, setStudentassessment] = useState({});

  const [checkedBoxes, setCheckedBoxes] = useState([]);

  let requireddocumentsArray;
  let checkboxes;
  let isChecked = true;


  useEffect(() => {
    async function init() {
      const result = await inventoryApi.fetchStaffMember();
      //console.log(result)
      if (result) {
        setStaffMember(result);

      } else {
        setStaffMember([]);

      }
    }
    init();


  }, []);

  useEffect(() => {
    if (assessment?.studentid) {
      setStudentassessment(assessment);
      if (assessment.requireddocuments != null) {
        //console.log("========= On update: use effect ===========");
        requireddocumentsArray = assessment.requireddocuments.split(",");
        //console.log("requireddocumentsArray===>>>", requireddocumentsArray);

        checkboxes = document.querySelectorAll('input[type="checkbox"]');
        //console.log("checkboxes===>>>", checkboxes);

        checkboxes.forEach((checkbox) => {
          //console.log('checkbox.value===>>>', checkbox.value);
          if (requireddocumentsArray.includes(checkbox.value)) {
            //console.log('=====***********************=====');
            checkbox.checked = true;
            setCheckedBoxes((prevState) => [...prevState, checkbox.value]);
            //setStudentassessment(assessment);
          }
        });
        //       setStudentassessment(assessment);
      }
    }
  }, []);

  const handleChange = (e) => {
    /**
     * RMKM Phase 2 Changes
     * added by @ali 
     * date : 9 April 2025
     * To make empty assistive_device_type,assistive_device_status fields when uses_assistive_device changed
     *  */
    if (e.target.name === 'uses_assistive_device' ) {
      studentassessment.assistive_device_type = '';
      studentassessment.assistive_device_status = '';
    }
    
    // /**
    // * RMKM Phase 2 Changes
    // * added by @ali 
    // * date : 14 April 2025
    // * Handle date fields (Cause of checked I have to Implement this logic)
    // *  */
    if (
      e.target.name === 'accessory_1_issued_on' ||
      e.target.name === 'accessory_2_issued_on' ||
      e.target.name === 'accessory_3_issued_on' ||
      e.target.name === 'accessory_4_issued_on' ||
      e.target.name === 'accessory_5_issued_on' 
    ) {
      setStudentassessment({ ...studentassessment, [e.target.name]: e.target.value });
    }

       
    console.log('e.target.name',e.target.name,e.target.value);
    if (e.target.checked) {
      setCheckedBoxes((prevState) => [...prevState, e.target.value]);
      return;
    } else if (e.target.checked == false) {
      setCheckedBoxes((prevState) => prevState.filter((box) => box !== e.target.value));
      return;
    }
    
    setStudentassessment({ ...studentassessment, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    studentassessment.requireddocuments = checkedBoxes.join(",");
    console.log("state enter in handle submit ", assessment);
    console.log("state enter in handle submit studentassessment ", studentassessment);
    e.preventDefault();
    let result = {};
    /**
    * RMKM Phase 2 Changes
    * added by @ali 
    * date : 14 April 2025
    * Handle default accessories issue date when user select accessory
    *  */
    studentassessment.accessory_1_issued_on = studentassessment?.accessory_1_issued_on ? moment(studentassessment.accessory_1_issued_on).format('YYYY-MM-DD') : null;
    studentassessment.accessory_2_issued_on = studentassessment?.accessory_2_issued_on ? moment(studentassessment.accessory_2_issued_on).format('YYYY-MM-DD') : null;
    studentassessment.accessory_3_issued_on = studentassessment?.accessory_3_issued_on ? moment(studentassessment.accessory_3_issued_on).format('YYYY-MM-DD') : null;
    studentassessment.accessory_4_issued_on = studentassessment?.accessory_4_issued_on ? moment(studentassessment.accessory_4_issued_on).format('YYYY-MM-DD') : null;
    studentassessment.accessory_5_issued_on = studentassessment?.accessory_5_issued_on ? moment(studentassessment.accessory_5_issued_on).format('YYYY-MM-DD') : null;

    
    if (studentassessment.id) {
      console.log('edit call');
      result = await inventoryApi.savePreAssessment(studentassessment);
      navigate(`/students/${studentassessment.studentid}`);
    } else {
      console.log('create call')
      studentassessment.studentid = assessment;
      result = await inventoryApi.createPreAssessment(studentassessment);
      console.log('result',result)
      if (result) {
        navigate(`/students/${assessment}`);
      }
    }
  };

  const handleCancel = (e) => {
    if (studentassessment.id) {
      navigate(`/students/${studentassessment.studentid}`, { state: studentassessment });
    } else {
      navigate(`/students/${assessment}`);
    }

  };

  return (
    <div>
      <Container>
        <Row className="view-form-header align-items-center mx-2">
          <Col lg={3}>
            <h5>Edit Assessment Info</h5>
          </Col>
          <Col lg={9} className="d-flex justify-content-end">
            {isEditable && <Button className="btn-sm mx-2" onClick={handleSubmit}>
              Save
            </Button>}
            <Button className="btn-sm" variant="danger" onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
        </Row>
        <fieldset disabled={!isEditable}>
          <div className="assessments my-3">
            <Row >
              <Col
                lg={8}
                className="section-header mx-4 my-3"
                style={{ width: "94%" }}
              >
                Form Part D Assessment
              </Col>
              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label form-label my-2">
                    Motor (Fine Motor/Gross Motor)
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="motor"
                    value={studentassessment.motor}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label my-2">
                    Self Help(ADL)
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="selfhelp"
                    value={studentassessment.selfhelp}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label form-label">
                    Communication (Verbal / Non Verbal)
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="communication"
                    value={studentassessment.communication}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label">Academics</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="academics"
                    value={studentassessment.academics}
                    onChange={handleChange}
                  />  
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label form-label">
                    Socialization
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="socialization"
                    value={studentassessment.socialization}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label">
                    Education Status
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="educationstatus"
                    value={studentassessment.educationstatus}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

            

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label form-label">
                  Vocational Status
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="vocationalstatus"
                    value={studentassessment.vocationalstatus}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>



              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label form-label">
                  co-morbidity
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="comobality"
                    value={studentassessment.comobality}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label">
                    Primary Diagnosis
                  </Form.Label>
                  <Form.Select name="primarydiagnosis" onChange={handleChange} value={studentassessment.primarydiagnosis}>
                    <option value="">-- Select --</option>
                    <option value="Blindness">Blindness</option>
                    <option value="Low-vision">Low-vision</option>
                    <option value="Leprosy Cured Persons">Leprosy Cured Persons</option>
                    <option value="Hearing Impairment">Hearing Impairment</option>
                    <option value="Locomotor Disability">Locomotor Disability</option>
                    <option value="Mental Illness">Mental Illness</option>
                    <option value="Autism Spectrum Disorder">Autism Spectrum Disorder</option>
                    <option value="Cerebral Palsy">Cerebral Palsy</option>
                    <option value="Muscular Dystrophy">Muscular Dystrophy</option>
                    <option value="Chronic Neurological Conditions">Chronic Neurological Conditions</option>
                    <option value="Specific Learning Disabilities">Specific Learning Disabilities</option>
                    <option value="Multiple Sclerosis">Multiple Sclerosis</option>
                    <option value="Speech and Language Disability">Speech and Language Disability</option>
                    <option value="Thalassemia">Thalassemia</option>
                    <option value="Hemophilia">Hemophilia</option>
                    <option value="Sickle Cell Disease">Sickle Cell Disease</option>
                    <option value="Multiple Disabilities including Deaf-blindness">Multiple Disabilities including Deaf-blindness</option>
                    <option value="Acid Attack Victims">Acid Attack Victims</option>
                    <option value="Parkinson's disease">Parkinson's Disease</option>
                    <option value="Intellectual Disability">Intellectual Disability</option>
                    <option value="Hard of hearing">Hard of hearing</option>


                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label className="form-view-label">Severity</Form.Label>
               
                  <Form.Select name="severity" onChange={handleChange} value={studentassessment.severity}>
                    <option value="">-- Select --</option>
                    <option value="Mild">Mild</option>
                    <option value="Moderate"> Moderate</option>
                    <option value="Sevear">Severe</option>
                    <option value="Profound">Profound</option>
                  </Form.Select>


                </Form.Group>
              </Col>

              {localStorage.getItem('userrole') === 'ADMIN' || localStorage.getItem('userrole') === 'SUPER_ADMIN' ? (
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Refer To</Form.Label>
                    <Form.Select
                      aria-label="Enter Select Type"
                      name="referto"
                      value={studentassessment.referto}
                      onChange={handleChange}
                    >
                      <option value=''>--Select--</option>
                      {staffMember && staffMember.map((item, index) => (
                        <option value={item.id} key={item.id}>{item.username}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              ) : null}
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label my-3">
                  Document Required
                </Form.Label>

                <Row md={4}>
                  <Col>
                    <Form.Check
                      inline
                      label="Disability Certificate"
                      name="requireddocuments"
                      type="checkbox"
                      value="Disability Certificate"
                      id={`inline-checkbox-1`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={6}>
                    {" "}
                    <Form.Check
                      inline
                      label="Birth Certificate"
                      name="requireddocuments"
                      type="checkbox"
                      value="Birth Certificate"
                      id={`inline-checkbox-2`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      label="UDID Registration"
                      name="requireddocuments"
                      type="checkbox"
                      value="UDID Registration"
                      id={`inline-checkbox-3`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      label="Aadhar Card"
                      name="requireddocuments"
                      type="checkbox"
                      value="Aadhar Card"
                      id={`inline-checkbox-4`}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>

                <Row md={4}>
                  <Col>
                    <Form.Check
                      inline
                      label="Pension Status"
                      name="requireddocuments"
                      type="checkbox"
                      value="Pension Status"
                      id={`inline-checkbox-5`}
                      onChange={handleChange}
                    />
                  </Col>

                  <Col>
                    <Form.Check
                      inline
                      label="Astha Card"
                      name="requireddocuments"
                      type="checkbox"
                      value="Astha Card"
                      id={`inline-checkbox-7`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      label="Niramaya Enrollment"
                      name="requireddocuments"
                      type="checkbox"
                      value="Niramaya Enrollment"
                      id={`inline-checkbox-8`}
                      onChange={handleChange}
                    />
                  </Col>

                  <Col>
                    <Form.Check
                      inline
                      label="Current Child Photo"
                      name="requireddocuments"
                      type="checkbox"
                      value="Current Child Photo"
                      id={`inline-checkbox-9`}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>

                <Row md={4}>

                  <Col>
                    <Form.Check
                      inline
                      label="Rail Pass"
                      name="requireddocuments"
                      type="checkbox"
                      value="Rail Pass"
                      id={`inline-checkbox-9`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      label="Bus Pass"
                      name="requireddocuments"
                      type="checkbox"
                      value="Bus Pass"
                      id={`inline-checkbox-9`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      label="Parents Consent Form"
                      name="requireddocuments"
                      type="checkbox"
                      value="Parents Consent Form"
                      id={`inline-checkbox-9`}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Check
                      inline
                      label="5-10 Sec. video clip of child"
                      name="requireddocuments"
                      type="checkbox"
                      value="5-10 Sec.video clip of child"
                      id={`inline-checkbox-10`}
                      onChange={handleChange}
                    />
                  </Col>
                  {/* <p>Checked boxes: {checkedBoxes.join(", ")}</p> */}
                </Row>
              </Form.Group>
              {
              /**
               * RMKM Phase 2 Changes
               * added by @ali 
               * date : 9 April 2025
               * Added some new fields uses_assistive_device,assistive_device_type,assistive_device_status as per client requirement
               *  */
              }
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Uses Any Assistive Device</Form.Label>
                  <Form.Select name="uses_assistive_device" onChange={handleChange} value={studentassessment.uses_assistive_device}>
                    <option value="">-- Select --</option>
                    <option value={'Yes'}>Yes</option>
                    <option value={'No'}> No</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              {studentassessment.uses_assistive_device === 'Yes' && <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Assistive Device Type</Form.Label>
                  <Form.Control as="textarea" rows={1} placeholder="Enter assistive device type" name="assistive_device_type"  onChange={handleChange} value={studentassessment?.assistive_device_type || ''} />
                </Form.Group>
              </Col>}

              {studentassessment.uses_assistive_device === 'No' && <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Assistive Device Status</Form.Label>
                  <Form.Select name="assistive_device_status" onChange={handleChange} value={studentassessment.assistive_device_status}>
                    <option value="">-- Select --</option>
                    <option value={'Will be required in the future'}>Will be required in the future</option>
                    <option value={'Not applicable'}>Not applicable</option>
                  </Form.Select>
                </Form.Group>
              </Col>}

              {
              /**
                * RMKM Phase 2 Changes
                * added by @ali 
                * date : 14 April 2025
                * Added some new fields accessories name & issue date as per client need
                *  */
              }
              <Col lg={12}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessories Provided by with the help of organization</Form.Label>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 1</Form.Label>
                  <Form.Select name="accessory_1_name" onChange={handleChange} value={studentassessment.accessory_1_name}>
                    <option value="">-- Select --</option>
                    {[ 'Aadhaar Card', 'Disability Certificate', 'Pension', 'Bus Pass', 'Rail Pass', 'Bank Account', 'Birth Certificate', 'Income Certificate', 'Ni Ramayya', 'Aastha Card', 'Jan Aadhaar', 'Job Card', 'UDID'].map((value,index)=><option value={value} key={index}>{value}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 1 Issue On</Form.Label>
                  <Form.Control onKeyDown={(e) => e.preventDefault()} type="date" name="accessory_1_issued_on" onChange={handleChange} value={studentassessment?.accessory_1_issued_on ? moment(studentassessment.accessory_1_issued_on).format('YYYY-MM-DD') : ''}/>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 2</Form.Label>
                  <Form.Select name="accessory_2_name" onChange={handleChange} value={studentassessment.accessory_2_name}>
                    <option value="">-- Select --</option>
                    {[ 'Aadhaar Card', 'Disability Certificate', 'Pension', 'Bus Pass', 'Rail Pass', 'Bank Account', 'Birth Certificate', 'Income Certificate', 'Ni Ramayya', 'Aastha Card', 'Jan Aadhaar', 'Job Card', 'UDID'].map((value,index)=><option value={value} key={index}>{value}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 2 Issue On</Form.Label>
                  <Form.Control onKeyDown={(e) => e.preventDefault()} type="date" name="accessory_2_issued_on" onChange={handleChange} value={moment(studentassessment.accessory_2_issued_on).format('YYYY-MM-DD')}/>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 3</Form.Label>
                  <Form.Select name="accessory_3_name" onChange={handleChange} value={studentassessment.accessory_3_name}>
                    <option value="">-- Select --</option>
                    {[ 'Aadhaar Card', 'Disability Certificate', 'Pension', 'Bus Pass', 'Rail Pass', 'Bank Account', 'Birth Certificate', 'Income Certificate', 'Ni Ramayya', 'Aastha Card', 'Jan Aadhaar', 'Job Card', 'UDID'].map((value,index)=><option value={value} key={index}>{value}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 3 Issue On</Form.Label>
                  <Form.Control onKeyDown={(e) => e.preventDefault()} type="date" name="accessory_3_issued_on" onChange={handleChange} value={moment(studentassessment.accessory_3_issued_on).format('YYYY-MM-DD')}/>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 4</Form.Label>
                  <Form.Select name="accessory_4_name" onChange={handleChange} value={studentassessment.accessory_4_name}>
                    <option value="">-- Select --</option>
                    {[ 'Aadhaar Card', 'Disability Certificate', 'Pension', 'Bus Pass', 'Rail Pass', 'Bank Account', 'Birth Certificate', 'Income Certificate', 'Ni Ramayya', 'Aastha Card', 'Jan Aadhaar', 'Job Card', 'UDID'].map((value,index)=><option value={value} key={index}>{value}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 4 Issue On</Form.Label>
                  <Form.Control onKeyDown={(e) => e.preventDefault()} type="date" name="accessory_4_issued_on" onChange={handleChange} value={moment(studentassessment.accessory_4_issued_on).format('YYYY-MM-DD')}/>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 5</Form.Label>
                  <Form.Select name="accessory_5_name" onChange={handleChange} value={studentassessment.accessory_5_name}>
                    <option value="">-- Select --</option>
                    {[ 'Aadhaar Card', 'Disability Certificate', 'Pension', 'Bus Pass', 'Rail Pass', 'Bank Account', 'Birth Certificate', 'Income Certificate', 'Ni Ramayya', 'Aastha Card', 'Jan Aadhaar', 'Job Card', 'UDID'].map((value,index)=><option value={value} key={index}>{value}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="my-2 mx-3">
                  <Form.Label className="form-view-label">Accessory 5 Issue On</Form.Label>
                  <Form.Control onKeyDown={(e) => e.preventDefault()} type="date" name="accessory_5_issued_on" onChange={handleChange} value={moment(studentassessment.accessory_5_issued_on).format('YYYY-MM-DD')}/>
                </Form.Group>
              </Col>

               
            </Row>
          </div>
        </fieldset>
        {
        /**
          * RMKM Phase 2 Changes
          * added by @ali 
          * date : 14 April 2025
          * Added footer as per client need
          *  */
        }
        <Row className="view-form-footer align-items-center mx-2">
          <Col lg={3}>
            <h5>Edit Assessment Info</h5>
          </Col>
          <Col lg={9} className="d-flex justify-content-end">
            {isEditable && <Button className="btn-sm mx-2" onClick={handleSubmit}>
              Save
            </Button>}
            <Button className="btn-sm" variant="danger" onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StudentAssessmentEdit;